import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";


import chat from './../media/icons/chat.png'
import file from './../media/icons/file.png'
import git from './../media/icons/git.png'
import { Vortex } from "../components/vortex";
import { images } from "../utilities/img";
import { icons } from "../utilities/icn";
import { setgtMessage } from "../redux/gtmsgSlice";
import { gtNeutral } from "../redux/gtstatusSlice";



const AccountManagement = () => {

    const dispatch = useDispatch()

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleStoreMessage = () => {
        dispatch(setgtMessage('Verification Processing'))
        dispatch(gtNeutral())
    }



    return ( 
        <div className="">

            <section id="home" className="home">
                
                {/* <div className="home-frame"> */}

                    <div className="home-account-management">

                        <div className="mgb-30">
                            <h1 className="inter mgb-20">How to Delete Your Account and Personal Data from ROSA</h1>
                            <h3 className="inter mgb-20">
                                At ROSA, your privacy and data control are important to us. If you wish to delete your account and all associated personal data, please follow the steps below:
                            </h3>

                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. <span>Visit your profile:</span> Go to <a href="https://neurosa.ai/profile" className="inter">https://neurosa.ai/profile</a> and log in to your account.</h4>
                                <h4 className="inter">2. <span>Access Data Management:</span> Click on the <span>"Delete Account Button"</span> at the bottom of your profile settings.</h4>
                                <h4 className="inter">3. <span>Request Deletion:</span> This will initiate permanent deletion of your account and all associated information.</h4>
                            </div>

                            <h2 className="inter mgb-20">What Data Will Be Deleted</h2>

                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">Your account details (username and email)</h4>
                                <h4 className="inter">Mood logs and wellness data</h4>
                                <h4 className="inter">Step tracking, heart rate, and sleep data</h4>
                                <h4 className="inter">Any associated metadata or personal activity logs</h4>
                            </div>

                            <h2 className="inter mgb-20">Retention Policy</h2>

                            <h4 className="inter">
                                Once you request deletion, your account and data will be <span className="inter">permanently deleted immediately</span>. 
                                We do not retain any personal data beyond that period unless legally required.
                            </h4>
                        </div>


                        <div className="">
                            <h1 className="inter mgb-20">How to Delete Your Personal Data from ROSA</h1>
                            <h3 className="inter mgb-20">
                                At ROSA, your privacy and data control are important to us. If you wish to delete all your associated data, please follow the steps below:
                            </h3>

                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">1. <span>Visit your profile:</span> Go to <a href="https://neurosa.ai/profile" className="inter">https://neurosa.ai/profile</a> and log in to your account.</h4>
                                <h4 className="inter">2. <span>Access Data Management:</span> Click on the <span>"Data Management"</span> section from your profile settings.</h4>
                                <h4 className="inter">3. <span>Request Deletion:</span> This will initiate permanent deletion of all your associated information and data.</h4>
                            </div>

                            <h2 className="inter mgb-20">What Data Will Be Deleted</h2>

                            <div className="grid grid-column-1 gap-20 mgb-20 home-am-left-pad">
                                <h4 className="inter">Mood logs and wellness data</h4>
                                <h4 className="inter">Step tracking, heart rate, and sleep data</h4>
                                <h4 className="inter">Any associated metadata or personal activity logs</h4>
                            </div>

                            <h2 className="inter mgb-20">Retention Policy</h2>

                            <h4 className="inter">
                                Once you request deletion, your account and data will be <span className="inter">permanently deleted immediately</span>. 
                                but your account is still intact. We do not retain any personal data beyond that period unless legally required.
                            </h4>
                        </div>

                    </div>

                {/* </div> */}


            </section>

            {/* <section className="rosa-infos" id="rosa-infos">
                
            </section> */}

            

            {/* <section className="wom" id="wom">
                <div className="main-frame">
                    <div className="cs-header">
                        <h2>The ROSA App</h2>
                    </div>
                    <div
                        className="cards-container"
                        ref={containerRef}
                        onMouseEnter={() => setPause(true)}
                        onMouseLeave={() => setPause(false)}
                    >
                        {womItems ? womItems.map((womItem, index) => (
                            <div key={index} className={`card cursor-pointer`}>
                                <div className="wom-image-box">
                                    <img src={womItem.fileLink} alt="" />
                                </div>
                            </div>
                        )) : null}
                    </div>
                </div>
            </section> */}

        </div>
    );
}
 
export default AccountManagement;